module.exports = __webpack_public_path__ + "static/media/signal.b7292965.svg";